import { CareAppListActionFactory } from '../action-factory';
import { MemoriamDto } from '@careapp-group/ng-sdk';

export class MemoriamActions extends CareAppListActionFactory<MemoriamDto> {
  get REQUEST_BY_CUSTOMER_ID() {
    return `[${this.type}][Request] Memoriam By Customer Id`;
  }
  get RESPONSE_SUCCESS_BY_CUSTOMER_ID() {
    return `[${this.type}][Response][Success] Memoriam By Customer Id`;
  }
  get RESPONSE_FAIL_BY_CUSTOMER_ID() {
    return `[${this.type}][Response][Fail] Memoriam By Customer Id`;
  }

  get RESPONSE_SUCCESS_NO_MEMORIAM() {
    return `[${this.type}][Response][Success] No Memoriam`;
  }

  get REQUEST_COMPLETE_MEMORIAM() {
    return `[${this.type}][Request] Complete Memoriam `;
  }
  get RESPONSE_SUCCESS_COMPLETE() {
    return `[${this.type}][Response][Success] Complete Memoriam`;
  }
  get RESPONSE_FAIL_COMPLETE() {
    return `[${this.type}][Response][Fail] Complete Memoriam`;
  }

  get REQUEST_REMOVE_MEMORIAM() {
    return `[${this.type}][Request] Remove Memoriam `;
  }
  get RESPONSE_SUCCESS_REMOVE() {
    return `[${this.type}][Response][Success] Remove Memoriam`;
  }
  get RESPONSE_FAIL_REMOVE() {
    return `[${this.type}][Response][Fail] Remove Memoriam`;
  }

  RequestByCustomerId(payload: { id: string }) {
    return {
      type: this.REQUEST_BY_CUSTOMER_ID,
      payload,
    };
  }

  ResponseFailByCustomerId(payload: { id: string; error: any }) {
    return {
      type: this.RESPONSE_FAIL_BY_CUSTOMER_ID,
      payload,
    };
  }

  ResponseSuccessByCustomerId(payload: { id: string; memoriam: any }) {
    return {
      type: this.RESPONSE_SUCCESS_BY_CUSTOMER_ID,
      payload,
    };
  }

  ResponseSuccessNoMemoriamAction(payload: { id: string }) {
    return {
      type: this.RESPONSE_SUCCESS_NO_MEMORIAM,
      payload,
    };
  }

  RequestCompleteMemoriam(payload: { id: string }) {
    return {
      type: this.REQUEST_COMPLETE_MEMORIAM,
      payload,
    };
  }

  ResponseSuccessComplete(payload: { id: string }) {
    return {
      type: this.RESPONSE_SUCCESS_COMPLETE,
      payload,
    };
  }

  ResponseFailComplete(payload: { id: string; error: any }) {
    return {
      type: this.RESPONSE_FAIL_COMPLETE,
      payload,
    };
  }

  RequestRemoveMemoriam(payload: { customerId: string; memoriamId: string }) {
    return {
      type: this.REQUEST_REMOVE_MEMORIAM,
      payload,
    };
  }

  ResponseSuccessRemove(payload: { memoriamId: string }) {
    return {
      type: this.RESPONSE_SUCCESS_REMOVE,
      payload,
    };
  }

  ResponseFailRemove(payload: { memoriamId: string; error: any }) {
    return {
      type: this.RESPONSE_FAIL_REMOVE,
      payload,
    };
  }

  constructor(modelName: string) {
    super(modelName);
  }
}
export const Memoriams = new MemoriamActions(`Memoriams`);
